import { render, staticRenderFns } from "./SellerOffersInsights.vue?vue&type=template&id=33df6dba&scoped=true"
import script from "./SellerOffersInsights.vue?vue&type=script&lang=js"
export * from "./SellerOffersInsights.vue?vue&type=script&lang=js"
import style0 from "./SellerOffersInsights.vue?vue&type=style&index=0&id=33df6dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33df6dba",
  null
  
)

export default component.exports